import { render, staticRenderFns } from "./SocialCallback.vue?vue&type=template&id=5faf8c54&"
import script from "./SocialCallback.vue?vue&type=script&lang=js&"
export * from "./SocialCallback.vue?vue&type=script&lang=js&"
import style0 from "./SocialCallback.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports